import { Link, Outlet } from "react-router-dom";
import engie from "../../assets/Logo-engie(1).svg";
import sharepoint_logo from "../../assets/sharepointLogo.png";
import styles from "./Layout.module.css";
import { usePowerPlant } from "../../components/powerplant";

interface LayoutProps {
    onShowGDPRModal: () => void;
}

const Layout = ({ onShowGDPRModal }: LayoutProps) => {
    const { selectedPlantId, selectedPlantDetails, isLoadingDetails } = usePowerPlant();
    console.log("Selected Plant:", selectedPlantId);
    console.log("Selected Plant Details:", selectedPlantDetails);
    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link
                        to={
                            selectedPlantDetails?.sharepointLibraryUrl ||
                            "https://engie.sharepoint.com/sites/AIteamISFlexGen-RAGfiles/SitePages/CollabHome.aspx"
                        }
                        className={styles.headerTitleContainer}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={sharepoint_logo} alt="Sharepoint Logo" className={styles.headerLogo} style={{ height: "48px", width: "48px" }} />
                        <h3 className={styles.headerTitle}>AlexandrIA Sharepoint</h3>
                    </Link>
                    <nav>
                        <div className={styles.headerContainer}>
                            <a
                                href="https://www.engie.be/nl/?gcdivd=Cj0KCQiAj_CrBhD-ARIsAIiMxT8cE5D3-Mbpb3pwzMYlInNEUdf5A4t4zZZWZ0PrbJqSH-77kQpB5TYaAsnkEALw_wcB&gclsrc=aw.ds"
                                target={"_blank"}
                                title="Engie logo"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={engie}
                                    alt="Engie logo"
                                    aria-label="Link to Engie homepage"
                                    width="80px"
                                    height="60px"
                                    className={styles.githubLogo}
                                />
                            </a>
                        </div>
                    </nav>
                    <div className={styles.headerRightContainer}>
                        <h4 className={styles.headerRightText}>Azure OpenAI + AI Search</h4>
                        <button onClick={onShowGDPRModal} className={styles.gdprButton} title="View GDPR Information">
                            GDPR Policy
                        </button>
                    </div>
                </div>
            </header>
            <Outlet />
        </div>
    );
};

export default Layout;
